import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer style={{ background: '#010101' }} className="border-t border-white/5">
      {/* Top strip */}
      <div className="border-b border-white/5">
        <div className="max-w-7xl mx-auto px-8 lg:px-20 py-6 flex items-center justify-between gap-4">
          <p className="font-sans text-[0.58rem] tracking-[0.3em] uppercase text-white/20">
            Broadcast-Level Production &nbsp;&bull;&nbsp; Central Florida
          </p>
          <div className="flex items-center gap-3">
            {['facebook-fill', 'instagram-line', 'youtube-fill', 'linkedin-fill'].map((icon) => (
              <a
                key={icon}
                href="#"
                rel="nofollow"
                className="w-8 h-8 flex items-center justify-center border border-white/6 text-white/25 hover:text-gold hover:border-gold/35 transition-all duration-300 cursor-pointer"
                aria-label={icon}
              >
                <i className={`ri-${icon} text-xs`} />
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Main footer grid */}
      <div className="max-w-7xl mx-auto px-8 lg:px-20 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex flex-col leading-none mb-7">
              <span className="font-serif text-2xl font-bold text-white tracking-[0.15em] uppercase">IMMANUEL</span>
              <span className="text-gold text-[0.52rem] tracking-[0.38em] uppercase font-sans font-medium mt-1">Production Group</span>
            </div>
            <p className="font-sans text-[0.75rem] text-white/28 leading-relaxed max-w-xs mb-8">
              Cinematic storytelling and broadcast-grade production for brands that demand authority, clarity, and lasting impact. Based in Oviedo, Central Florida. Available worldwide.
            </p>
            <div className="flex items-start gap-3 mb-3">
              <i className="ri-map-pin-2-line text-gold/50 text-xs mt-0.5 flex-shrink-0" />
              <p className="font-sans text-[0.72rem] text-white/28 leading-relaxed">
                Oviedo, Central Florida, FL
              </p>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-mail-line text-gold/50 text-xs flex-shrink-0" />
              <a
                href="mailto:info@immanuelproductiongroup.com"
                rel="nofollow"
                className="font-sans text-[0.72rem] text-white/28 hover:text-gold transition-colors"
              >
                info@immanuelproductiongroup.com
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="md:col-span-3">
            <h4 className="font-sans text-[0.58rem] tracking-[0.28em] uppercase text-gold mb-6 font-semibold">
              <a href="/services">Services</a>
            </h4>
            <ul className="space-y-3">
              {[
                ['Corporate Video Production', '/services'],
                ['Brand Story Films', '/services'],
                ['Live Streaming Services', '/services'],
                ['Event Coverage', '/services'],
                ['Photography Services', '/services'],
                ['Creative Direction', '/services'],
              ].map(([s, href]) => (
                <li key={s}>
                  <Link to={href} className="font-sans text-[0.72rem] text-white/28 hover:text-gold transition-colors cursor-pointer leading-relaxed flex items-center gap-2 group">
                    <div className="w-1 h-1 bg-gold/20 group-hover:bg-gold flex-shrink-0 transition-colors duration-300" />
                    {s}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company + Service Areas */}
          <div className="md:col-span-4">
            <h4 className="font-sans text-[0.58rem] tracking-[0.28em] uppercase text-gold mb-6 font-semibold">
              <a href="/about">Company</a>
            </h4>
            <ul className="space-y-3 mb-8">
              {[['About Us', '/about'], ['Our Services', '/services'], ['Service Areas', '/location'], ['Contact Us', '/contact'], ['Get a Quote', '/contact']].map(([label, href]) => (
                <li key={label}>
                  <Link to={href} className="font-sans text-[0.72rem] text-white/28 hover:text-gold transition-colors cursor-pointer">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>

            <h4 className="font-sans text-[0.58rem] tracking-[0.28em] uppercase text-gold mb-4 font-semibold">
              <a href="/location">Service Cities</a>
            </h4>
            <div className="flex flex-wrap gap-x-3 gap-y-1">
              {['Oviedo', 'Orlando', 'Tampa', 'Miami', 'Jacksonville', 'Fort Lauderdale'].map((city) => (
                <Link
                  key={city}
                  to="/location"
                  className="font-sans text-[0.65rem] text-white/22 hover:text-gold transition-colors cursor-pointer"
                >
                  {city}
                </Link>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-white/5 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-sans text-[0.62rem] text-white/18 tracking-wide">
            &copy; {new Date().getFullYear()} Immanuel Production Group. All rights reserved.
          </p>
          <p className="font-sans text-[0.62rem] text-white/18">
            Est. 2005 &nbsp;&bull;&nbsp; <strong className="text-white/30">20+ Years</strong> of Broadcast Excellence &nbsp;&bull;&nbsp; Oviedo, Central Florida, FL
          </p>
        </div>
      </div>
    </footer>
  );
}
